import { call, select } from 'redux-saga/effects';
import { EffectRT } from '@app/react/saga/common/effectRT';
import { getPathParams } from '@app/react/common/getPathParams';
import {
    KINTEKI, ENTEKI, MAKIWARA, ArrowType,
} from '@app/react/const/type';

import {
    EntekiArrowModel,
    KintekiArrowModel,
    MakiwaraArrowModel,
} from '@app/react/3d/ArrowModelInterface';
import {
    kintekiModel,
    entekiModel,
    makiwaraModel,
} from '@app/react/reducer/OrdermadeArrowModelReducer';
import {
    shaftFetchAndApplyWithModel,
    haneFetchAndApplyWithModel,
    haneFetchAndApplyWithEntekiModel,
    haneFetchAndApplyWithMakiwaraModel,
    threadFetchAndApplyWithModel,
    kebikiFetchAndApplyWithModel,
    nockFetchAndApplyWithModel,
    arrowheadFetchAndApplyWithModel,
    twineFetchAndApplyWithModel,
    lameFetchAndApplyWithModel,
    familycrestFetchAndApplyWithModel,
    familycrestColorFetchAndApplyWithModel,
    carvingColorFetchAndApplyWithModel,
    carvingFetchAndApplyWithModel,
    decorationFetchAndApplyWithModel,
    featherinsideFetchAndApplyWithModel,
    threadGlossWithModel,
    changeThreadModeWithModel,
} from './parts';
import { GetModelHandler } from './common';

const getModel: GetModelHandler = () => kintekiModel;
const getModel2: GetModelHandler = () => entekiModel;
const getModel3: GetModelHandler = () => makiwaraModel;

function* getModelWithParams(): Generator<
    any,
    [ReturnType<GetModelHandler>, ArrowType] | [],
    any
> {
    const params = getPathParams();
    const arrowType = params?.params.arrowType;
    const orderType = params?.params.orderType;
    if (arrowType === undefined || orderType === undefined) {
        console.error('[saga] not found arrow type from get model');
        return [];
    }

    const handler = ((at) => {
        switch (at) {
            case KINTEKI:
                return getModel;
            case ENTEKI:
                return getModel2;
            case MAKIWARA:
                return getModel3;
            default:
                return () => null;
        }
    })(arrowType);

    const model = yield select<GetModelHandler>(handler);
    if (model === null) {
        return [];
    }

    return [model, arrowType];
}

export function* shaftFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(shaftFetchAndApplyWithModel, model);
}

export function* haneFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model, arrowType]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }

    switch (arrowType) {
        case KINTEKI:
            yield call(haneFetchAndApplyWithModel, model as KintekiArrowModel);
            break;
        case ENTEKI:
            yield call(
                haneFetchAndApplyWithEntekiModel,
                model as EntekiArrowModel,
            );
            break;
        case MAKIWARA:
            yield call(
                haneFetchAndApplyWithMakiwaraModel,
                model as MakiwaraArrowModel,
            );
            break;
        default:
            break;
    }
}

export function* threadFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(threadFetchAndApplyWithModel, model);
}

export function* threadGloss(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(threadGlossWithModel, model);
}

export function* kebikiFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(kebikiFetchAndApplyWithModel, model);
}

export function* nockFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(nockFetchAndApplyWithModel, model);
}

export function* arrowheadFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(arrowheadFetchAndApplyWithModel, model);
}

export function* twineFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(twineFetchAndApplyWithModel, model);
}

export function* lameFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(lameFetchAndApplyWithModel, model);
}

export function* familycrestFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model, arrowType]: EffectRT<typeof x> = yield x;
    if (model === undefined) {
        return;
    }

    switch (arrowType) {
        case KINTEKI:
            yield call(
                familycrestFetchAndApplyWithModel,
                model as KintekiArrowModel,
            );
            break;
        default:
            break;
    }
}

export function* familycrestColorFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model, arrowType]: EffectRT<typeof x> = yield x;
    if (model === undefined) {
        return;
    }

    switch (arrowType) {
        case KINTEKI:
            yield call(
                familycrestColorFetchAndApplyWithModel,
                model as KintekiArrowModel,
            );
            break;
        default:
            break;
    }
}

export function* carvingColorFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(carvingColorFetchAndApplyWithModel, model);
}

export function* carvingFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(carvingFetchAndApplyWithModel, model);
}

export function* decorationFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    yield call(decorationFetchAndApplyWithModel, model);
}

export function* featherinsideFetchAndApply(): Generator<any, any, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }

    yield call(featherinsideFetchAndApplyWithModel, model);
}

export function* resetMaterial(): Generator<any, void, any> {
    const x = call(getModelWithParams);
    const [model]: EffectRT<typeof x> = yield x;
    if (model === undefined || model === null) {
        return;
    }
    model.reset();
}

export function* changeThreadMode(): Generator<any, void, any> {
    const x = call(getModelWithParams);
    const [model, arrowType]: EffectRT<typeof x> = yield x;
    if (model === undefined) {
        return;
    }

    switch (arrowType) {
        case MAKIWARA:
            yield call(changeThreadModeWithModel, model as MakiwaraArrowModel);
            break;
        default:
            break;
    }
}
